import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Head from '../../../components/Partials/Head/Head';
import Auxiliary from '../../../hoc/Auxiliary';
import ServiceBanner from '../../../components/ServiceBanner/ServiceBanner';
import satelliteIcon from '../../../components/Satellites/satelliteIcon';
import satelliteLinks from '../../../components/Satellites/satelliteLinks';
import CustomVsStandardSoftware2 from '../../../components/Satellites/customSoftware/CustomVsStandardSoftware/CustomVsStandardSoftware2/CustomVsStandardSoftware2';
import CustomVsStandardSoftware3 from '../../../components/Satellites/customSoftware/CustomVsStandardSoftware/CustomVsStandardSoftware3/CustomVsStandardSoftware3';
import CustomVsStandardSoftware4 from '../../../components/Satellites/customSoftware/CustomVsStandardSoftware/CustomVsStandardSoftware4/CustomVsStandardSoftware4';
import CustomVsStandardSoftware5 from '../../../components/Satellites/customSoftware/CustomVsStandardSoftware/CustomVsStandardSoftware5/CustomVsStandardSoftware5';
import CustomVsStandardSoftware6 from '../../../components/Satellites/customSoftware/CustomVsStandardSoftware/CustomVsStandardSoftware6/CustomVsStandardSoftware6';
import CustomVsStandardSoftware7 from '../../../components/Satellites/customSoftware/CustomVsStandardSoftware/CustomVsStandardSoftware7/CustomVsStandardSoftware7';
import CustomVsStandardSoftware8 from '../../../components/Satellites/customSoftware/CustomVsStandardSoftware/CustomVsStandardSoftware8/CustomVsStandardSoftware8';
import CustomVsStandardSoftware9 from '../../../components/Satellites/customSoftware/CustomVsStandardSoftware/CustomVsStandardSoftware9/CustomVsStandardSoftware9';

class CustomVsStandardSoftware extends Component {
  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="custom_vs_standard_software" />
        <ServiceBanner {...this.props} page="customVsStandardSoftware" icon={satelliteIcon} textComponents={satelliteLinks(this.props.t)} />
        <CustomVsStandardSoftware2 {...this.props} />
        <CustomVsStandardSoftware3 {...this.props} />
        <CustomVsStandardSoftware4 {...this.props} />
        <CustomVsStandardSoftware5 {...this.props} />
        <CustomVsStandardSoftware6 {...this.props} />
        <CustomVsStandardSoftware7 {...this.props} />
        <CustomVsStandardSoftware8 {...this.props} />
        <CustomVsStandardSoftware9 {...this.props} />
      </Auxiliary>
    )
  }
}
export default withTranslation()(CustomVsStandardSoftware);
